import React, { FC } from 'react'
import styles from 'styles/components/label.module.scss'

type Props = {
  label: string
}

const FilterLabel: FC<Props> = (props) => {
  const { label } = props
  return <p className={styles.order__filter}>{label}</p>
}

export default FilterLabel
